import React from 'react';
import cc from 'currency-codes';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import constants from 'lib/constants';
const Option = Select.Option;
const FormItem = Form.Item;

const CURRENCIES = [];

constants.currencyCodes.forEach(code => {
  CURRENCIES.push(cc.code(code));
});

const SelectCurrency = ({ onChange, initialValue, label, value }) => {
  return (
    <Select onChange={onChange} value={value || initialValue} size="large" style={{ width: '100%' }}>
      {CURRENCIES.map(item => {
        return (
          <Option key={item.code} value={item.code}>
            {item.currency} ({item.code})
          </Option>
        );
      })}
    </Select>
  );
};

SelectCurrency.propTypes = {};

SelectCurrency.defaultProps = {};

export default SelectCurrency;



// WEBPACK FOOTER //
// ./src/components/inputs/SelectCurrency/index.js